export default __webpack_public_path__ + "static/media/suter.45570a48.png";